import { ReactNode } from 'react'

import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { MemberLabel } from 'src/components/MemberLabel/MemberLabel'
import { TrialMemberRole } from 'src/lib/gql-client'

import { SPExplanationRoomHeader } from '../SPExplanationRoomHeader/SPExplanationRoomHeader'

type Props = {
  headerTitle: String
  trialUid: string
  explanationInfo: ExplanationInfo
  isAgreementCompletedOrRejected: boolean
  children: ReactNode
}

export const SPPatientLobbyLayout: React.FC<Props> = ({
  headerTitle,
  trialUid,
  explanationInfo,
  isAgreementCompletedOrRejected,
  children,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <Stack spacing="0" height="100svh">
      <InformationModal
        isOpen={isOpen}
        explanationInfo={explanationInfo}
        onClose={onClose}
      />
      <SPExplanationRoomHeader
        trialUid={trialUid}
        title={headerTitle}
        isAgreementCompletedOrRejected={isAgreementCompletedOrRejected}
        onClickMenu={onOpen}
        showLeaveButton
      />
      {children}
    </Stack>
  )
}

type ExplanationInfo = {
  trialName: string
  hospitalName: string
  candidateId: string
  members: {
    index: number
    role: TrialMemberRole
    name: string
  }[]
}

type ModalProps = {
  isOpen: boolean
  explanationInfo: ExplanationInfo
  onClose: () => void
}
const InformationModal: React.FC<ModalProps> = ({
  isOpen,
  explanationInfo,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xs">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody px="4" m="0">
          <Stack spacing="8">
            <Box>
              <Text fontSize="lg" fontWeight="bold">
                {explanationInfo.trialName}
              </Text>
            </Box>
            <Stack spacing="1.5">
              <Text fontSize="lg" fontWeight="bold" as="h2">
                候補ID
              </Text>
              <Text>{explanationInfo.candidateId}</Text>
            </Stack>
            <Stack spacing="1.5">
              <Text fontSize="lg" fontWeight="bold" as="h2">
                説明担当者
              </Text>
              <Box>
                <Text fontWeight="bold" as="h3">
                  {explanationInfo.hospitalName}
                </Text>
                <Stack spacing="1" pl="4" mt="2">
                  {explanationInfo.members
                    .sort((a, b) => a.index - b.index)
                    .map(m => (
                      <MemberLabel
                        key={m.index}
                        role={m.role}
                        displayName={m.name}
                      />
                    ))}
                </Stack>
              </Box>
            </Stack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
